import React, { useState, useEffect } from 'react';
import { GetServiceSection } from "../../../apis/VenuesAPI";
import AvailableServices from "../../AvailableServices";

import style from "./style.module"

const LazyLoadingServiceSection = (props) => {
  const { sectionId, orderingEnabled, onShowModal } = props

  const [section, setSection] = useState(null)

  useEffect(() => {
    GetServiceSection(sectionId).then(response => {
      setSection(response)
    }).catch(error => console.log(error))

  }, [sectionId])


  if (!section) {
    return <div>Carico...</div>
  }

  const { title, description, services, service_section_part_configs } = section

  return (
    <div className={style.container}>
      <div className={style.title}>{title}</div>
      <div className={style.description}>{description}</div>
      <AvailableServices services={services}
                         onShowModal={onShowModal}
                         serviceSectionPartConfigs={service_section_part_configs}
                         orderingEnabled={orderingEnabled}/>
    </div>
  );

}

export default LazyLoadingServiceSection;
